import { useSelected } from '../../../core';
import { PicklistElement } from './PicklistElement';
import type { PicklistPluginElement, ReportPicklistBeforeSubmissionOptions } from '../types';
import type { ReactElement, ReactNode } from 'react';
import type { RenderElementProps } from '../../../core';

type PicklistBuilderProps = {
  attributes: RenderElementProps['attributes'];
  options: ReadonlyArray<ReportPicklistBeforeSubmissionOptions>;
  children: ReactNode | Array<ReactNode>;
  element: PicklistPluginElement;
  ['data-editor-element']?: string;
  variant?: string;
};

export const PicklistBuilder = ({
  attributes,
  options = [],
  children,
  element,
  variant,
  ...rest
}: PicklistBuilderProps): ReactElement => {
  const selected = useSelected();

  return (
    <>
      <PicklistElement
        {...attributes}
        element={element}
        selected={selected}
        data-editor-element={rest['data-editor-element']}
        variant={variant}
      >
        {children}
      </PicklistElement>
    </>
  );
};
